<template>
  <div>
      <body>
    <div
      style="
        background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
      "
    >
      <CRow class="ml-5 mr-5 mb-5">
        <Mainlayout></Mainlayout>
        <br /><br /><br />
      </CRow>

      <CContainer>
        <div class="text-center d-sm-down-none">
          <CCol sm="12">
            <CRow>
              <CCol sm="4"
                ><img style="max-width: 100%" src="../assets/img/blog.svg"
              /></CCol>
              <CCol sm="8"
                ><img style="max-width: 100%" src="../assets/img/blog1.png" />
                <h3 class="custom-64px text-white text-center">
                  Info in your hands
                </h3>
                <h4 class="text-white text-left">
                  Our blog delivers valuable and informative content on various
                  aspects of education in Malaysia, including current updates on
                  the country's education system, policies, and strategies.
                </h4></CCol
              >
            </CRow>
          </CCol>
        </div>
      </CContainer>
    

      <CRow>
        <div class="card-custom-web" style="background: #fff">
          <CContainer>
            <CRow class="mt-3">
              <CCol sm="4" v-for="item in blog" v-bind:key="item.id">
                <CCard
                  class="custom-orange-card text-left m-2"
                  @click="GoToDetail(item.Title)"
                >
                  <span class="text-right">
                    <img
                      v-if="item.Image != null"
                      :src="getPic(item)"
                      style="height: 300px"
                      class="custom-bg-advetise"
                    />
                    <img
                      v-else
                      src="../assets/img/Thumbnail.svg"
                      style="height: 300px"
                      class="custom-bg-advetise"
                    />
                  </span>
                </CCard>
                <div>
                  <label
                    class="ml-3 text-black"
                    style="font-size: 25px; font-weight: 500"
                  >
                    {{ truncateText(item.Title, 30) }}
                  </label>
                  <br />
                  <label class="ml-3">{{
                    truncateText(removeInlineStyles(item.Content), 60)
                  }}</label>
                  <h6 class="ml-3 text-black">
                    by <span class="text-blue">{{ item.Creator }}</span>
                  </h6>
                  <div
                    class="custom-seemore ml-3"
                    @click="GoToDetail(item.Title)"
                  >
                    See More >>
                  </div>
                </div>
              </CCol>
            </CRow>
          </CContainer>
          >
        </div>
      </CRow>
    </div>

    <Footerlayout></Footerlayout>
  </body>
  </div>
</template>
          
          
          
          
          <script>
import Vue from "vue";
import VueMeta from "vue-meta";

Vue.use(VueMeta);

// import Translator from "vue-gtranslate";
// import "vue-gtranslate/translator.css";

Vue.use(require("vue-moment"));
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

import Mainlayout from "../containers/AllHeaderLanding.vue";
import Footerlayout from "../containers/TheFooter.vue";

import VueAgile from "vue-agile";
Vue.use(VueAgile);

import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import _ from "lodash";
new Vue({
  el: "#navbar",

  data() {
    return {
      view: {
        topOfPage: true,
      },
    };
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.pageYOffset > 400) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
          el.setAttribute(
            "style",
            "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
          );
        }
      } else {
        if (!this.view.topOfPage) this.view.topOfPage = true;
        el.setAttribute(
          "style",
          "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
        );
      }
    },
  },
});
export default {
  metaInfo: {
    title: 'Blog - Explore our hand-picked collection of top lists blog on various topics ',
    meta: [
      { property: 'og:title', content: 'Blog - Explore our hand-picked collection of top lists blog on various topics' }
    ],
    link: [
        { rel: 'canonical', href: 'https://www.pickiddo.com/Blog' }
      ]
  },
  name: "Login",
  components: {
    Mainlayout,
    Footerlayout,
  },
  data() {
    return {
      blog: [],
      detailForm: true,
    };
  },
  created() {
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);

 


    // if (window.location.hostname !== "www.pickiddo.com/Blog") {
    //   window.location.href = "https://www.pickiddo.com/Blog";
    // }
  
  },
  async mounted() {
    this.GetBlog();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  computed: {
    
  },

  methods: {
    removeInlineStyles(html) {
      const div = document.createElement("div");
      div.innerHTML = html;
      const elements = div.querySelectorAll("*");
      elements.forEach((element) => {
        element.removeAttribute("style");
      });
      return div.textContent;
    },
    truncateText(text, limit) {
      if (text.length > limit) {
        return text.slice(0, limit) + "...";
      } else {
        return text;
      }
    },
    getBadge(status) {
      switch (status) {
        case "Active":
          return "success";
        case "Inactive":
          return "secondary";
        case "Pending":
          return "warning";
        case "Banned":
          return "danger";
        default:
          "primary";
      }
    },
    onScroll() {
      // Get the current scroll position
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return;
      }
      // Here we determine whether we need to show or hide the navbar
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition;
    },
    handleScroll() {
      if (window.pageYOffset > 1000) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
        } else {
          this.view.topOfPage = true;
        }
      }
    },
    GetBlog() {
      this.$API
        .get(this.$ListBlog, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.blog = response.data;
            this.getPic(this.blog.Image);
          }
        });
    },
    getPic(item) {
      return "https://pickiddo.com/blogs/" + item.Image;
    },
    GoToDetail(Title) {
     // this.$router.push("DetailBlog?blogId=" + BlogId);
     this.$router.push(`/DetailBlog/${Title.replace(/\s+/g, '-')}`);
     
    },
  },
};
</script>
              <style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");

.c-header {
  /* background: rgb(23, 77, 124);
            background: linear-gradient(92deg, #174d7c, #1b7682);
            border-bottom: 0.01px solid #1a6783;
            border-bottom: 1px solid #636f83; */

  background: transparent;
  border-bottom: 0;
  border-bottom: 0;
  /* color: #fff; */
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  font-family: "Montserrat", sans-serif;
}
body {
  font-family: "Montserrat", sans-serif;
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  font-family: "Montserrat", sans-serif;
}
label {
  font-family: "Montserrat", sans-serif;
}

body nav.onScroll {
  box-shadow: 0 0 10px #aaa;
  background-color: rgb(255, 255, 255);
  font-family: "Montserrat";
  font-style: normal;
}
body nav.onScroll ul li {
  color: #10b761;
}
body nav ul {
  margin-left: 3em;
  width: 25%;
  display: flex;
  justify-content: space-between;
}
body nav ul li {
  cursor: pointer;
  font-weight: 600;
  list-style-type: none;
  color: white;
}
body {
  top: 0 !important;
  font-family: "Montserrat", sans-serif;
}

input {
  border-bottom: 2px solid #fff;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: -webkit-fill-available;
  -webkit-text-fill-color: white !important;
}
input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.custom-user-input {
  /* Body/1/Semibold */

  display: flex;
  justify-content: center;
  flex-flow: row nowrap;
}

.js-click:active {
  background: #e8f4ff;
  border-radius: 20px;
  border: 1px solid #e8f4ff;
}

.js-click:focus {
  background: #e8f4ff;
  border-radius: 20px;
  border: 1px solid #e8f4ff;
}
</style>